import React from 'react';
import PropTypes from 'prop-types';
import DrugAccessList from './DrugAccessList';

const TabDrugAccess = (props) => {
    const { customerId, customerName } = props;
    return (
        <>
            <DrugAccessList customerId={customerId} customerName={customerName} />
        </>
    );
};

TabDrugAccess.propTypes = {
    customerName: PropTypes.object.isRequired,
    customerId: PropTypes.object.isRequired,
};

export default TabDrugAccess;
